<template>
<div class="app-statistics">
	<div class="container">
		<!-- Header -->
		<div class="page-header flex-center">
			<h1 class="page-title">Supplier Report</h1>
			<div class="page-header-right text-right ml-a">
				<!-- Date Filter -->
				<daterangepicker
					:presets="filterDatePresets"
					:start="since"
					:end="until"
					@selected="setFilterDate"
					ref="datePicker"
				>
				</daterangepicker>
			</div>
		</div>

		<div class="page-content">
			<div
				class="p-4 text-center"
				v-if="isStatisticFetching">
				<div class="is-loading large dark"></div>
			</div>
			<div class="app-stats" v-if="!isStatisticFetching && stats">
				<div class="row">
					<div class="col-md-6 col-lg-4">
						<overview
							:text="'Supplier'"
							:type="'normal'"
							:with-additional="false"
							:icon="'bi-house'"
							:iconType="'bootstrap'"
							:number="stats.supplier_count"
							:stats="stats">
						</overview>
					</div>
					<div class="col-md-6 col-lg-4">
						<overview
							:text="'Total Produk'"
							:type="'normal'"
							:with-additional="false"
							:icon="'bi-box2-heart'"
							:iconType="'bootstrap'"
							:number="stats.product_count"
							:stats="stats">
						</overview>
					</div>
					<div class="col-md-6 col-lg-4">
						<overview
							:text="'Total Item Terjual'"
							:type="'normal'"
							:with-additional="false"
							:icon="'bi-cart2'"
							:iconType="'bootstrap'"
							:number="stats.product_sold"
							:stats="stats">
						</overview>
					</div>
				</div>
				<hr>
			</div>
			<div class="row mb-2 d-flex justify-content-end">
				<div class="col-auto mb-2">
					<!-- Export -->
					<div class="dropdown export ml-auto">
						<button
							type="button"
							class="btn btn-light dropdown-toggle flex-center"
							data-toggle="dropdown"
							:class="{ 'is-loading': isExporting }"
						>
							<i class="material-icons">save_alt</i>
							<span class="mr-2">{{ $t('Export') }}</span>
						</button>
						<div class="dropdown-menu">
							<button
								type="button"
								class="dropdown-item"
								:class="{ 'is-loading': isExporting }"
								@click="exportSupplierReport('filtered')">
								{{ $t('Export Filtered') }}
							</button>
							<button
								type="button"
								class="dropdown-item"
								:class="{ 'is-loading': isExporting }"
								@click="exportSupplierReport('all')">
								{{ $t('Export All') }}
							</button>
						</div>
					</div>
				</div>
				<div class="col-md-3">
					<input
						type="text"
						class="form-control"
						placeholder="Username Supplier"
						v-focus
						@input="onKeywordChange"
						v-model="keyword">
				</div>
			</div>
			<div
				class="submissions-list table-responsive b-0"
				id="supplier-list">
				<table
					class="table table-primary table-striped table-hover table--small submissions-list-table"
					id="supplier-list-table">
					<thead>
						<tr>
							<th
								class="th-sort text-center"
								:class="sortClass('name')"
								@click="changeSorting('name')"
							>
								Supplier
							</th>
							<th
								class="th-sort text-center"
								:class="sortClass('product_count')"
								@click="changeSorting('product_count')"
							>
								Jumlah Produk
							</th>
							<th
								class="th-sort text-center"
								:class="sortClass('product_sold')"
								@click="changeSorting('product_sold')"
							>
								Item Terjual
							</th>
							<th
								class="th-sort text-center"
								:class="sortClass('product_completed')"
								@click="changeSorting('product_completed')"
							>
								Sukses Terkirim
							</th>
							<th
								class="th-sort text-center"
								:class="sortClass('product_processing')"
								@click="changeSorting('product_processing')"
							>
								On Proses
							</th>
							<th
								class="th-sort text-center"
								:class="sortClass('product_canceled')"
								@click="changeSorting('product_canceled')"
							>
								Gagal Terkirim
							</th>
							<th
								class="th-sort text-center"
								:class="sortClass('product_revenue')"
								@click="changeSorting('product_revenue')"
							>
								Revenue
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(supplier) in suppliers"
							:key="supplier._id"
						>
							<td>
								<!-- <div class="d-flex align-items-center">
									<div><img :src="supplier.picture" alt="profile-picture"></div>
									<div class="mx-2"><img src="/img/user-default.png" alt="profile-picture" width="45" height="45" style="border-radius: 50%;"></div>
									<div class="text-bold text-primary" style="font-size: 16px;">{{ supplier.name }}</div>
								</div> -->
								<div class="row">
									<div class="col-xl-3 d-flex align-items-center justify-content-xl-center pr-0">
										<img :src="supplier.picture ? supplier.picture : '/img/user-default.png'" alt="profile-picture" width="45" height="45" style="border-radius: 50%;">
									</div>
									<div class="col-xl-9 text-bold text-primary d-flex align-items-center" style="font-size: 16px;">
										{{ supplier.name }}
									</div>
								</div>
							</td>
							<td>
								<div class="text-center">{{ supplier.product_count ? supplier.product_count : 0 }}</div>
							</td>
							<td>
								<div class="text-center">{{ supplier.product_sold ? supplier.product_sold : 0 }}</div>
							</td>
							<td>
								<div class="text-center">{{ supplier.product_completed ? supplier.product_completed : 0 }}</div>
							</td>
							<td>
								<div class="text-center">{{ supplier.product_processing ? supplier.product_processing : 0 }}</div>
							</td>
							<td>
								<div class="text-center">{{ supplier.product_canceled ? supplier.product_canceled : 0 }}</div>
							</td>
							<td>
								<div class="text-center">{{ supplier.product_revenue ? formatMoney(supplier.product_revenue) : formatMoney(0) }}</div>
							</td>
						</tr>
					</tbody>
				</table>

				<div
					class="list-empty table-empty text-center"
					v-if="keyword !== '' && suppliers.length === 0 && !isFetching">
					<b>No Supplier Found</b>
				</div>

				<!-- Loader -->
				<div
					class="my-4 p-4 text-center"
					v-if="isFetching">
					<div class="is-loading dark large"></div>
				</div>

				<div class="table-vertical-scroll hidden-sm" id="orders-list-vertical-scroll">
					<div class="table-vertical-scroll-content" id="orders-list-vertical-scroll-content"></div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Overview from '@/components/Overview.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
import supplierApi from '@/api/supplier';
import adminApi from '@/api/admin';
import { getDateRange, duplicateVar, downloadFile } from '@/lib/helper';

const defaultFilterDate = getDateRange();

export default {
	name: 'supplierReport',
	components: {
		Overview,
		Daterangepicker,
	},
	data() {
		return {
			stats: false,
			isStatisticFetching: false,
			isFetching: false,
			filterDate: null,
			since: null,
			until: null,
			suppliers: [],
			page: 1,
			limit: 100,
			sort_by: 'created_at',
			sort: 'desc',
			isAll: false,
			keyword: '',
			isExporting: false,
		};
	},
	methods: {
		...mapActions({
		}),
		fetchDataStatistic() {
			this.isStatisticFetching = true;

			const dateFormat = 'YYYY-MM-DD';

			this.since = this.moment(this.filterDate.start).format(dateFormat);
			this.until = this.moment(this.filterDate.end).format(dateFormat);

			const params = {
				since: this.since,
				until: this.until,
			};

			const callback = (response) => {
				this.stats = response.data;
				this.isStatisticFetching = false;
			};

			const errorCallback = () => {
				this.isStatisticFetching = false;
			};

			supplierApi.getSupplierStatistic(params, callback, errorCallback);
		},
		resetItems() {
			this.orders = [];
			this.isAll = false;
			this.page = 1;
		},
		fetchDataReport(reset = true) {
			this.isFetching = true;

			if (reset) {
				this.resetItems();
			}

			const params = this.fetchParams;

			const callback = (response) => {
				const supplier = response.data;
				this.isFetching = false;

				if (supplier.length > 0) {
					this.page++;
					this.suppliers = this.orders.concat(supplier);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			supplierApi.getSupplierReport(params, callback, errorCallback);
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				this.suppliers = [];
				self.fetchDataReport();
			}, 1000);
		},
		setFilterDate(filterDate) {
			this.$set(this, 'filterDate', filterDate);
			this.suppliers = [];
			this.fetchDataStatistic();
			this.fetchDataReport();
		},
		initFilterDate() {
			const filterDate = duplicateVar(defaultFilterDate);
			this.$set(this, 'filterDate', filterDate);
		},
		checkListTable() {
			const ordersList = document.getElementById('supplier-list');
			if (ordersList) {
				const ordersListVerticalScroll = document.getElementById('orders-list-vertical-scroll');
				const documentHeight = document.documentElement.clientHeight;
				const scrollTop = document.documentElement.scrollTop;
				const ordersListHeight = ordersList.offsetHeight;
				const offsetTop = ordersList.offsetTop;
				const offsetBottom = offsetTop + ordersListHeight;
				const scrollBottom = offsetBottom - scrollTop;
				const topTreshold = 100;
				const scrollTreshold = offsetTop - (documentHeight - topTreshold);
				const display = scrollTop >= scrollTreshold && scrollBottom >= documentHeight ? 'block' : 'none';
				ordersListVerticalScroll.style.display = display;
			}
		},
		onDocumentScroll(event) {
			if (event.target === document) {
				this.checkListTable();
			} else if (event.target.id === 'supplier-list') {
				const element = event.target;
				const scrollLeft = element.scrollLeft;
				const ordersListVerticalScroll = document.getElementById('orders-list-vertical-scroll');
				ordersListVerticalScroll.scrollLeft = scrollLeft;
			} else if (event.target.id === 'orders-list-vertical-scroll') {
				const element = event.target;
				const scrollLeft = element.scrollLeft;
				const ordersList = document.getElementById('supplier-list');
				ordersList.scrollLeft = scrollLeft;
			}
		},
		setVerticalScroll() {
			const ordersList = document.getElementById('supplier-list');
			if (ordersList) {
				const ordersListTable = document.getElementById('supplier-list-table');
				const ordersListVerticalScroll = document.getElementById('orders-list-vertical-scroll');
				const ordersListVerticalScrollContent = document.getElementById('orders-list-vertical-scroll-content');
				const listWidth = ordersList.offsetWidth;
				const listLeft = ordersList.offsetLeft;
				const tableWidth = ordersListTable.offsetWidth;
				ordersListVerticalScroll.style.width = `${listWidth}px`;
				ordersListVerticalScroll.style.left = `${listLeft}px`;
				ordersListVerticalScrollContent.style.width = `${tableWidth}px`;
			}
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 100;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchDataReport(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.suppliers = [];
			this.fetchDataReport(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		exportSupplierReport(type = 'filtered') {
			this.isExporting = true;
			const params = this.fetchParams;
			if (type === 'all') {
				delete params.since;
				delete params.until;
			}
			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			adminApi.exportSupplierReport(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			filterDatePresets: 'filterDatePresets',
			appName: 'appName',
		}),
		fetchParams() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);
			const keyword = this.keyword.trim();

			const params = {
				page: this.page,
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				since: startDate,
				until: endDate,
				keyword,
			};

			return params;
		},
	},

	created() {
		document.addEventListener('scroll', this.onDocumentScroll, true);
		window.addEventListener('resize', this.checkListTable, true);
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);
		this.initFilterDate();
		this.fetchDataStatistic();
		this.fetchDataReport();
	},
	destroyed() {
		document.removeEventListener('scroll', this.onDocumentScroll, true);
		window.removeEventListener('resize', this.checkListTable, true);
		window.removeEventListener('scroll', this.handleScroll);
	},
	updated() {
		this.$nextTick(() => {
			this.setVerticalScroll();
			this.checkListTable();
		});
	},
};
</script>
